export default __webpack_public_path__ + "static/media/Falcon.0b5c6f52.png";